<!--  -->
<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// import { CapacitorFacade } from '@/plugins/capacitorPlugin';
// import { unsupportedBrowser } from '@/shared/util/helpers';
import { useGlobalStore } from '@/stores/global/global.store';
import { mapStores } from 'pinia';

export default defineComponent({
  name: 'PreLogin',
  data() {
    return {
      error: '',
    };
  },
  computed: {
    ...mapStores(useGlobalStore),
  },
  created() {},
});
</script>
